module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-battle-schedule-32-active.65004319.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-battle-schedule-32-active.png
// module id = 3180
// module chunks = 11